<template>
<div class="chapter">
<div class="inner_page">
<p class="ind" id="start" style="margin-top:20px;"><a id="epigraph">“The <i>gentleman</i> tells us that America is obstinate; that America is almost in open rebellion. Sir, I rejoice that America has resisted…</a></p><a id="epigraph">
<p class="ind">“The gentleman asks when were the colonies emancipated. But I desire to know when they were made slaves…</p>
<p class="ind">“They are subjects of this kingdom, equally entitled with yourselves to all the natural rights of mankind, and the peculiar privileges of Englishmen; equally bound by its laws, and equally participating in the constitution of this free country. The Americans are the sons, not the bastards, of England.”</p>
<p class="right" style="margin-top:20px;">1766:</p>
<p class="right">William Pitt the Elder,</p>
<p class="right">before Parliament,</p>
<p class="right">in support of repeal</p>
<p class="right">of the Stamp Act.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5-start.vue?67eb2582